import React, { memo } from 'react';
import { CTAButton } from './Shared';
export const HeroSection = () => {
  return <header className="relative overflow-hidden" data-id="element-125">
      <div className="bg-grid absolute inset-0 pointer-events-none" data-id="element-126" />
      <div className="absolute inset-0 bg-gradient-to-b from-familia-bg to-familia-section opacity-50 pointer-events-none" data-id="element-127" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 pt-6 pb-10 text-center" data-id="element-128">
        <p className="text-familia-gold font-semibold text-[10px] sm:text-xs uppercase tracking-[0.25em] mb-2" data-id="element-129">
          Vitalidad 360 · Master Kit Adultos Mayores
        </p>

        <h1 className="font-display sm:text-4xl md:text-5xl font-bold mb-4 text-[24px]" data-id="element-130">
          El sistema de actividades para adultos mayores que ayuda a las
          <br className="hidden md:block" data-id="element-131" />
          <span className="text-familia-cyan" data-id="element-132">
            {' '}
            familias a dejar de improvisar
          </span>
        </h1>

        {/* Mockup directly below the title */}
        <div className="relative max-w-[320px] sm:max-w-[460px] md:max-w-[560px] mx-auto mb-5" style={{
        aspectRatio: '3 / 2'
      }} data-id="element-133">
          <div aria-hidden="true" className="absolute inset-0 bg-familia-cyan/20 rounded-full hidden md:block" style={{
          filter: 'blur(70px)'
        }} data-id="element-134" />
          <img src="https://cdn.magicpatterns.com/uploads/nQuCFAXjN5rWqH1CYg6bzM/ChatGPT_Image_28_may_2026__09_10_42_p.m.-removebg-preview.png" alt="Vitalidad 360 Master Kit — Kinesiólogo presentando el sistema" width="560" height="373" loading="eager" className="relative z-10 w-full h-full object-contain" style={{
          filter: 'drop-shadow(0 12px 24px rgba(0,0,0,0.45))'
        }} data-id="element-135" />
        </div>

        <p className="text-familia-gray sm:text-sm max-w-xl mx-auto mb-4 text-[11px] leading-relaxed" data-id="element-136">
          Más de 300 actividades físicas y cognitivas organizadas por niveles
          para estimular la mente, acompañar el movimiento y organizar el
          cuidado desde casa. 5 módulos completos + Módulo Maestro + 3 bonos,
          con letra grande e instrucciones claras para familias y cuidadores.
        </p>

        <div className="flex flex-wrap gap-1.5 mb-4 items-start justify-center" data-id="element-137">
          {['📄 Producto digital en PDF', '⚡ Acceso inmediato', '👴 Familias y cuidadores', '🕒 Rutinas desde 15 minutos'].map((badge, i) => <span key={i} className="bg-familia-card border border-familia-cyan/25 px-2.5 py-1 rounded-full text-[9px] sm:text-[11px] font-bold flex items-center gap-1.5" data-id="element-138">
              {badge}
            </span>)}
        </div>

        <CTAButton href="#precio-lanzamiento" className="w-full sm:w-auto text-base px-10 py-3.5 mb-3" data-id="element-139">
          QUIERO ACCEDER AL MASTER KIT
        </CTAButton>

        <div className="max-w-xl mx-auto mb-3 rounded-lg border border-familia-green/40 bg-familia-green/15 px-4 py-3 text-[11px] sm:text-xs text-white leading-relaxed" data-id="element-140">
          <p className="font-bold" data-id="element-141">
            🌎 Disponible para familias, cuidadores y profesionales de habla
            hispana en cualquier país.
          </p>
          <p data-id="element-142">
            Producto digital en PDF · acceso inmediato · pago único · garantía
            de 30 días. El precio se muestra en USD y tu banco o emisor realiza
            la conversión a tu moneda local.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-1.5 text-[9px] sm:text-[11px] text-familia-gray" data-id="element-143">
          <span className="flex items-center gap-1.5" data-id="element-144">
            🛡️ Garantía de satisfacción de 30 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-145">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1.5" data-id="element-146">
            💳 Tarjetas de Crédito/Débito
          </span>
        </div>
      </div>
    </header>;
};